import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import FantasyFacade from "./Facade/FantasyFacade";

export default class Fantasy {
  private facade: FantasyFacade = null;

  constructor(config: SDKConfigurationModel) {
    this.facade = new FantasyFacade(config);
  }

  public getConfig = async () => {
    return await this.facade.getConfig();
  };

  public getPlayersPoints = async (
    templateId: string,
    playersPosition?: string,
    disableCache?: boolean
  ) => {
    return await this.facade.getPlayersPoints(
      templateId,
      playersPosition,
      disableCache
    );
  };

  public getPlayerDetailedStatistics = async (
    templateId: string,
    playerId: string,
    disableCache?: boolean
  ) => {
    return await this.facade.getPlayerDetailedStatistics(
      templateId,
      playerId,
      disableCache
    );
  };

  public play = async (
    templateId: string,
    groupId: string,
    playerIds: string[],
    playersRoles?: Map<string, string> | null
  ) => {
    return await this.facade.play(templateId, groupId, playerIds, playersRoles);
  };

  public getMyPrediction = async (templateId: string, groupId: string) => {
    return await this.facade.getMyPrediction(templateId, groupId);
  };

  public getPlayerStatistics = async (
    templateId: string,
    playerId: string,
    disableCache?: boolean
  ) => {
    return await this.facade.getPlayerStatistics(
      templateId,
      playerId,
      disableCache
    );
  };

  public getGameWeekStatistics = async (templateId: string) => {
    return await this.facade.getGameWeekStatistics(templateId);
  };
}
